import { Typography } from '@mui/material';
import { Dialog } from '../../components/Dialog';
import { Spinner } from '../../components/Spinner';

function ValidationResultItem({ validationResult }) {
  const field = validationResult.uncertifiedField || {};
  return (
    <div>
      <Typography variant="body1">{field.fieldName}</Typography>
      {validationResult.errors && validationResult.errors.length > 0 && (
        <ul style={{ margin: 0 }}>
          {validationResult.errors.map((error, i) => (
            <li key={`${i}-${error.type}-${error.message}`}>
              {error.type} {error.message}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}

export default function ValidationResults(props) {
  const { validationResults, handleClose, dialogMode } = props;
  const filter = (type) =>
    validationResults?.filter((r) => r.validationResult === type) || [];

  const passedResults = filter('passed');
  const failedResults = filter('failed');

  return (
    <Dialog
      width="sm"
      title={buildTitle()}
      onCancel={handleClose}
      onSave={handleClose}
      actions={false}
    >
      {validationResults ? buildResults() : buildLoading()}
    </Dialog>
  );

  function buildLoading() {
    return <Spinner sx={{ mt: 3, height: 80 }} />;
  }

  function buildResults() {
    return (
      <>
        <Typography variant="h6">Passed</Typography>
        {passedResults.map((validationResult) => (
          <ValidationResultItem
            key={validationResult.uncertifiedField.objectId}
            validationResult={validationResult}
          />
        ))}

        <Typography variant="h6" style={{ marginTop: '1em' }}>
          Failed
        </Typography>
        {failedResults.map((validationResult) => (
          <ValidationResultItem
            key={validationResult.uncertifiedField.objectId}
            validationResult={validationResult}
          />
        ))}
      </>
    );
  }

  function buildTitle() {
    if (/uncertify/i.test(dialogMode)) return 'Uncertify Fields';
    if (/certify/i.test(dialogMode)) return 'Certify Fields';
    return 'Validate Fields';
  }
}
